// src/constants/routes.js
export const ROUTES = {
  REGISTRATION: "/registration",
  ADMINSIGNIN: '/login',
  ADMINFORGOTPASSWORD: '/admin-forgot-password',
  DASHBOARD: "/dashboard",
  REMOTE: "/remote",
  MAINHOME: "/home",
  HOME: "/",
  SCHOOLMANAGEMENT: "/school-management",
  ADMINMANAGEMENT: "/admin-management",
  HELPDESK: "/helpdesk",
  SCHOOLLIST: "/school-list",
  PRIVACYPOLICY:'/privacy-notice',
  TERMS:'/terms',
 GROUPLIST:'grouplist'
 
};

export const ROLES = {
  ADMIN: "admin"
};
